/* eslint-disable */

import React, { PropsWithChildren } from 'react';
import { Colors, FontSize } from '@common/tokens';
import { Icon } from '@common/components';
import { WorksListItemStateType } from '@onboarding/graphql';

type Props = {
  status: WorksListItemStateType | 'new';
  size?: 'lg';
};

export function ComplianceItemStatusIcon({ status, size }: Props) {
  const StatusIcon = () => {
    if (['pending'].includes(status)) {
      return <Icon icon="circle" kind="regular" size={size} />;
    }

    if (['rejected', 'expired'].includes(status)) {
      return <Icon icon="exclamationTriangle" kind="solid" size={size} />;
    }

    if (['inactive'].includes(status)) {
      return <Icon icon="circleMinus" kind="solid" size={size} />;
    }

    if (['submitted', 'new'].includes(status)) {
      return <Icon icon="circle" kind="solid" size={size} />;
    }

    if (['approved'].includes(status)) {
      return <Icon icon="checkCircle" kind="solid" size={size} />;
    }

    return <>Something went wrong.</>;
  };

  return (
    <>
      <span
        className={`compliance-status-icon compliance-status-icon--${status} compliance-status-icon--${size}`}
      >
        <StatusIcon />
      </span>

      <style jsx>{`
        .compliance-status-icon--approved {
          color: ${Colors.grass};
        }
        .compliance-status-icon--pending,
        .compliance-status-icon--inactive {
          color: ${Colors.steelDarker};
        }
        .compliance-status-icon--rejected {
          color: ${Colors.coral};
        }
        .compliance-status-icon--submitted {
          color: ${Colors.sunDarker};
        }
        .compliance-status-icon--large {
          font-size: ${FontSize.xl};
        }
      `}</style>
    </>
  );
}
